/// <amd-module name="Repos/Views/CommitHub/CommitData" />
import { GitPush, GitUserDate, VersionControlChangeType } from "Repos/Common/Contracts/Git";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const commitDetailsDataProviderId = "ms.vss-code-web.commit-details-view-data-provider";

interface GitChangeItem {
    isFolder: boolean;
    isSymLink: boolean;
    path?: string;
    serverItem?: string;
}

export interface GitCommitChange {
    changeType: VersionControlChangeType;
    commitId: string;
    item: GitChangeItem;
    sourceServerItem?: string;
}

interface GitCommitObject {
    full: string;
    short: string;
}

interface GitCommitDetails {
    author: GitUserDate;
    changes: GitCommitChange[];
    comment: string;
    committer: GitUserDate;
    commitId: GitCommitObject | string;
    parents: string[];
    push: GitPush;
    commitTooManyChanges: boolean;
}

interface IDiffParentDetails {
    diffParent: GitCommitDetails;
    parentId: string;
}

interface ICommitDataProviderData {
    allChangesIncluded: boolean;
    commitDetails: GitCommitDetails;
    diffParentDetails?: IDiffParentDetails;
}

export function getCommitData(pageContext: IVssPageContext): ICommitDataProviderData | undefined {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService.getData<ICommitDataProviderData>(commitDetailsDataProviderId);
}
